module.exports = __webpack_public_path__ + "img/icon_fwsm.21b64481.png";